import { useMemo } from 'react';

import type { IdentifiedTileGridBlockTile } from './useIdentifiedTileGridBlockData';
import { useTrackTileGridSearch } from './useTrackTileGridSearch';

function normalizeForSearch(text: string) {
  return text.toLowerCase();
}

type Args = {
  query: string;
  identifiedTiles: IdentifiedTileGridBlockTile[];
};

export function useTileGridSearch({ query, identifiedTiles }: Args) {
  const normalizedQuery = normalizeForSearch(query);

  const identifiedSearchTiles = useMemo(() => {
    if (!normalizedQuery) return undefined;

    return identifiedTiles.filter((tile) => {
      const normalizedSubjects = [tile.heading, tile.subHeading]
        .filter(Boolean)
        .map(normalizeForSearch);

      return normalizedSubjects.some((normalizedSubject) =>
        normalizedSubject.includes(normalizedQuery),
      );
    });
  }, [identifiedTiles, normalizedQuery]);

  useTrackTileGridSearch({ query });

  return { identifiedSearchTiles };
}
